import { render, staticRenderFns } from "./InstantMilkChange.vue?vue&type=template&id=bb309f9e"
import script from "./InstantMilkChange.vue?vue&type=script&lang=js"
export * from "./InstantMilkChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports